//src/components/configuration/standard/displayVariant.js
//utilities for converting pixel maps to specific sign variants
//Phase 4 (Standard) signs only
export default function displayVariant(sign){
   
    var getSize = (mysign) => {
        if(mysign 
          && mysign.sign_type_obj
          && mysign.sign_type_obj.opt_width !== null
          && mysign.sign_type_obj.opt_height !== null){
            return {
                width : mysign.sign_type_obj.class_width * mysign.sign_type_obj.opt_width,
                height : mysign.sign_type_obj.class_height * mysign.sign_type_obj.opt_height,
                split : mysign.sign_type_obj.opt_height > 1 && mysign.sign_type_obj.opt_width === 5 ? 3 : 0
            }

        }
        return {
            width : 30,
            height: 18,
            split : 3
        }
    }

    var convertMap = (map) => {
        let size = getSize(sign);
        if(size.height < 18 && size.width > 30){
            let leftpanels = map.split(',').slice(0, 9).map(n => n.substring(30 - (size.width - 30)));
			let rightpanels = map.split(',').slice(18 - size.height);
            return rightpanels.map((r, i) => leftpanels[i]+r).join(',');
        }
        var pmap = map;
        if(size.height < 18){
            pmap = pmap.split(',').slice(18 - size.height).join(',');
        }
        if(size.width < 30 && pmap){
            pmap = pmap.split(',').map((line, l) => line.substring(30 - size.width)).join(',');
        }
        return pmap;
    }

    const compileMap = (map) => {
		let rows = map.split(',');
		//wider than 5 panels with right-justified wrap
		if(rows.length < 18 && rows[0].length > 30){
			let firstrow = rows.map(r => '0'.repeat(30 - (r.length - 30))+r.substring(0,  r.length - 30));
			let lastrow = rows.map(r => r.substring(r.length - 30));
			return firstrow.concat(lastrow).join(',');
		}
		if(map.split(',').length < 18){
			map = '0,'.repeat(18 - map.split(',').length)+map;
		}
		return map.split(',').map((line) => {
			if(line.length < 30)
				return '0'.repeat(30 - line.length)+line;
			return line;
		}).join(',');
	}

    const numDigits = (mysign) => {
        if(mysign.sign_type_obj){
			if(mysign.sign_type_obj.class_width){
                return parseInt(mysign.sign_type_obj.opt_digits);
			}
		}
        return 0;
    }

    return {
        size : getSize(sign),
        getSize : getSize,
        extract : convertMap,
        compile : compileMap,
        digits : numDigits(sign)
    }
}